<ng-template [ngIf]="panel">
  <a [title]="panel.title | translate"
     [attr.data-test]="panel.code"
     [routerLink]="link?.path"
     [queryParams]="link?.parameters"
     class="content-type"
     [class.simple]="displayMode === 'simple'"
     [class.active]="isActive()">
    <div class="content-type-action" (click)="onClick($event)">
      <div class="icon-wrap">
        <app-icon width="30" height="30" [icon]="getIconName()"></app-icon>
      </div>

      <div class="right">
        <span class="label"
              [class.bold]="displayMode !== 'simple'"
              [class.normal]="displayMode === 'simple'">{{ panel.title | translate }}</span>

        <div appRedPoint class="red-point" [event]="redPointEvent()"></div>

        <span class="total">{{ 'library.content-filter.total' | translate }} {{ panel.total_count }}</span>
      </div>
    </div>
  </a>
</ng-template>
